import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Link } from 'react-router'
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'
import { ArrowRight, Euro } from 'lucide-react'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Guide des prix travaux 2026 — AfficheServices' },
  { name: 'description', content: 'Combien coûtent vos travaux ? Consultez nos guides de prix : plomberie, électricité, peinture, rénovation et plus.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/guide-prix' },
  { property: 'og:image', content: 'https://www.afficheservices.fr/api/og?title=Guide+des+prix&subtitle=25+guides+detailles' },
]

const GUIDES = [
  { slug: 'plombier', title: 'Combien coûte un plombier ?', range: '80 — 500 €', unit: 'par intervention', desc: 'Dépannage, installation, remplacement.' },
  { slug: 'electricien', title: 'Prix d\'un électricien', range: '150 — 1 500 €', unit: 'par projet', desc: 'Mise aux normes, installation, dépannage.' },
  { slug: 'peinture', title: 'Prix peinture au m²', range: '20 — 45 €/m²', unit: 'fournitures comprises', desc: 'Peinture intérieure et extérieure.' },
  { slug: 'renovation-salle-de-bain', title: 'Rénovation salle de bain', range: '3 000 — 15 000 €', unit: 'tout compris', desc: 'Budget complet pour rénover votre SDB.' },
  { slug: 'renovation-cuisine', title: 'Rénovation cuisine', range: '5 000 — 25 000 €', unit: 'tout compris', desc: 'De la peinture à la refonte complète.' },
  { slug: 'toiture', title: 'Prix réparation toiture', range: '500 — 5 000 €', unit: 'par projet', desc: 'Réparation, rénovation, isolation.' },
  { slug: 'serrurerie', title: 'Tarifs serrurier', range: '80 — 400 €', unit: 'par intervention', desc: 'Ouverture de porte, changement serrure.' },
  { slug: 'carrelage', title: 'Prix pose carrelage', range: '25 — 70 €/m²', unit: 'fournitures comprises', desc: 'Carrelage sol et mural.' },
  { slug: 'isolation', title: 'Prix isolation maison', range: '20 — 200 €/m²', unit: 'selon technique', desc: 'Combles, murs ITE/ITI, phonique.' },
  { slug: 'climatisation', title: 'Prix climatisation', range: '500 — 5 000 €', unit: 'par installation', desc: 'Split, multi-split, PAC air-air.' },
  { slug: 'pompe-a-chaleur', title: 'Prix pompe à chaleur', range: '5 000 — 25 000 €', unit: 'fourni-posé', desc: 'PAC air-eau, air-air, géothermique.' },
  { slug: 'menuisier', title: 'Prix menuisier', range: '200 — 3 000 €', unit: 'par élément', desc: 'Fenêtres, portes, placards, volets.' },
  { slug: 'maconnerie', title: 'Prix maçonnerie', range: '40 — 200 €/m²', unit: 'fourni-posé', desc: 'Mur, dalle, ouverture, enduit.' },
  { slug: 'parquet', title: 'Prix pose parquet', range: '15 — 150 €/m²', unit: 'fourni-posé', desc: 'Stratifié, contrecollé, massif.' },
  { slug: 'ravalement', title: 'Prix ravalement façade', range: '15 — 200 €/m²', unit: 'échafaudage inclus', desc: 'Nettoyage, peinture, enduit, ITE.' },
  { slug: 'demenagement', title: 'Prix déménagement', range: '300 — 5 000 €', unit: 'selon volume', desc: 'Local, longue distance, garde-meuble.' },
  { slug: 'jardinage', title: 'Prix jardinier', range: '30 — 80 €/h', unit: 'par heure', desc: 'Tonte, élagage, création jardin.' },
  { slug: 'nettoyage', title: 'Prix nettoyage', range: '20 — 50 €/h', unit: 'par heure', desc: 'Ménage, fin de chantier, vitres.' },
  { slug: 'piscine', title: 'Prix construction piscine', range: '1 000 — 60 000 €', unit: 'selon type', desc: 'Hors-sol, coque, béton, naturelle.' },
  { slug: 'panneaux-solaires', title: 'Prix panneaux solaires', range: '7 000 — 22 000 €', unit: 'fourni-posé', desc: '3 à 9 kWc, autoconsommation.' },
  { slug: 'salle-de-bain-pmr', title: 'Prix salle de bain PMR', range: '5 000 — 12 000 €', unit: 'tout compris', desc: 'Douche accessible, barres, WC PMR.' },
  { slug: 'chaudiere-gaz', title: 'Prix chaudière gaz', range: '2 000 — 6 000 €', unit: 'fourni-posé', desc: 'Condensation murale et sol.' },
  { slug: 'borne-recharge', title: 'Prix borne de recharge', range: '300 — 3 500 €', unit: 'fourni-posé', desc: 'Wallbox 7-22 kW, prise renforcée.' },
  { slug: 'vmc', title: 'Prix VMC', range: '500 — 5 000 €', unit: 'fourni-posé', desc: 'Simple flux, double flux, hygro.' },
  { slug: 'chauffe-eau', title: 'Prix chauffe-eau', range: '500 — 7 000 €', unit: 'fourni-posé', desc: 'Électrique, thermodynamique, solaire.' },
]

export default function GuidePrixIndex() {
  return (
    <div className="min-h-screen bg-surface-secondary">
      <Navbar />

      <div className="mx-auto max-w-7xl px-4 py-12 lg:px-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-slate-900">Guide des prix travaux 2026</h1>
          <p className="mt-3 text-slate-500">
            Estimez le coût de vos travaux grâce à nos guides basés sur des données réelles
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {GUIDES.map((g, i) => {
            const colors = [
              'bg-blue-50 text-blue-600 border-blue-100',
              'bg-amber-50 text-amber-600 border-amber-100',
              'bg-rose-50 text-rose-600 border-rose-100',
              'bg-emerald-50 text-emerald-600 border-emerald-100',
              'bg-violet-50 text-violet-600 border-violet-100',
              'bg-cyan-50 text-cyan-600 border-cyan-100',
              'bg-orange-50 text-orange-600 border-orange-100',
              'bg-teal-50 text-teal-600 border-teal-100',
            ]
            const c = colors[i % colors.length]
            const [bgClass, textClass] = [c.split(' ')[0], c.split(' ')[1]]
            return (
            <Link key={g.slug} to={`/guide-prix/${g.slug}`}
              className="card-hover group rounded-2xl border border-border bg-white p-6 shadow-xs">
              <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${bgClass} ${textClass}`}>
                <Euro className="h-5 w-5" />
              </div>
              <h2 className="mt-4 text-base font-semibold text-slate-900 group-hover:text-primary">{g.title}</h2>
              <p className="mt-1 text-lg font-bold text-primary">{g.range}</p>
              <p className="text-[10px] font-medium text-slate-400">{g.unit}</p>
              <p className="mt-2 text-sm text-slate-500">{g.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary group-hover:gap-2 transition-all">
                Voir le guide <ArrowRight className="h-3 w-3" />
              </span>
            </Link>
            )
          })}
        </div>

        <p className="mt-6 text-center text-[10px] text-slate-400">
          * Prix indicatifs TTC basés sur les devis reçus en 2025-2026. Les tarifs varient selon la région, la complexité et l'artisan.
        </p>

        <div className="mt-12 rounded-2xl bg-slate-900 p-8 text-center sm:p-12">
          <h2 className="text-2xl font-bold text-white">Obtenez un prix exact pour votre projet</h2>
          <p className="mt-2 text-slate-400">Demandez des devis personnalisés à des pros vérifiés</p>
          <Link to="/demande-devis/1" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-primary px-8 py-3.5 text-sm font-semibold text-white shadow-md hover:bg-primary-hover btn-press">
            Devis gratuit <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      {/* Pricing methodology */}
      <section className="border-t border-slate-100 bg-white py-14">
        <div className="mx-auto max-w-3xl px-4 lg:px-6">
          <h2 className="text-xl font-bold text-slate-900">Comment sont calculés nos prix de référence</h2>
          <div className="mt-6 space-y-3 text-sm leading-relaxed text-slate-600">
            <p>Les prix affichés dans nos guides sont des <strong>moyennes nationales</strong> calculées à partir des devis réels collectés sur notre plateforme, croisées avec les données de la FFB (Fédération Française du Bâtiment) et les indices de prix de l'INSEE.</p>
            <p><strong>Variations régionales :</strong> Les tarifs en Île-de-France sont en moyenne 20-30 % supérieurs à la moyenne nationale. Les grandes métropoles (Lyon, Marseille, Bordeaux) affichent un surcoût de 10-15 %. Les zones rurales pratiquent des prix 5-10 % inférieurs, mais les frais de déplacement peuvent compenser l'écart.</p>
            <p><strong>Facteurs de variation :</strong> Le prix d'une intervention dépend de la complexité technique, de l'urgence (majoration de 50-100 % le soir et le week-end), de l'accessibilité du chantier, de l'ancienneté de l'installation, et des matériaux choisis. Comparer 3 devis détaillés reste le meilleur moyen d'obtenir un prix juste.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
